<template>
  <div>
    <div class="activity-item" v-for="(item, index) in list" :key="index">
      <div class="item-time">{{ $t('shared.filter.time') }}: {{ item.localCreateTime }}</div>
      <div class="item-body">
        <div class="item-info">
            <div class="info-title" v-if="item.nickName">{{ item.nickName }} {{ $t('shared.updateStoreInfoBy') }} <span style="color: #307bff;">{{ item.module === 'Event' ? $t('form.popUp') : item.module }}</span></div>
            <div class="info-desc">{{ item.changeSummary }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="less" scoped>
.activity-item {
  background-color: #fff;
  margin-bottom: 1px; // Divider effect
  border-bottom: 1px solid #f0f0f0;

  .item-time {
    font-size: 13px;
    color: #000;
    padding: 12px 10px 10px 10px;
    border-bottom: 1px solid #f0f0f0;
  }

  .item-body {
    display: flex;
    padding: 10px 16px;

    .item-image-box {
      width: 60px;
      height: 60px;
      margin-right: 12px;
      border: 1px solid #999;
      flex-shrink: 0;

      // Placeholder X style
      .placeholder-img {
        width: 100%;
        height: 100%;
        position: relative;
        background-color: #fff;

        .line1,
        .line2 {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%; // full width relative to box
          height: 1px;
          background-color: #999;
        }

        .line1 {
          transform: translate(-50%, -50%) rotate(45deg);
          width: 141%; // sqrt(2) * 100% to reach corners
        }

        .line2 {
          transform: translate(-50%, -50%) rotate(-45deg);
          width: 141%;
        }

        overflow: hidden; // clip the lines
      }
    }

    .item-info {
      flex: 1;
      display: flex;
      flex-direction: column;

      .info-title {
        font-size: 14px;
        color: #000;
        margin-bottom: 16px;
      }

      .info-desc {
        font-size: 14px;
        color: #666;
      }
    }
  }
}
</style>
